/*
 * Relocates the PDP Convert variant buybox (data-pdp-embed) into the main product
 * buybox slot on DOMContentLoaded. Convert only toggles visibility via
 * data-ab="buybox-control" / data-ab="buybox-variant".
 *
 * On combined-product option changes, product-rerender fully replaces its subtree.
 * A document capture listener detaches the relocated buybox before that swap; a form
 * bubble listener re-inserts it synchronously after replaceWith completes. The form
 * listener is registered after product-rerender connects so it runs last on the
 * non-bubbling product:rerender event. Re-insert must finish before selectCombination
 * returns — variant-picker calls Shopify.PaymentButton.init() immediately after
 * product:rerender, and dynamic checkout markup not in the DOM at that moment stays
 * uninitialized.
 */
(function () {
  const VARIANT_BUYBOX_SELECTOR = '[data-ab="buybox-variant"][data-pdp-embed]';
  let preservedBuybox = null;

  function relocatePdpConvertVariantBuybox() {
    const slot = document.querySelector("[data-convert-variant-slot]");
    if (!slot) return;

    const buybox = document.querySelector(VARIANT_BUYBOX_SELECTOR);
    if (!buybox || slot.contains(buybox)) return;

    const sectionEl = buybox.closest(".shopify-section");
    slot.appendChild(buybox);

    if (sectionEl) {
      sectionEl.classList.add("shopify-section--pdp-embed-empty");
    }
  }

  function onProductChangeRerender(event) {
    return Boolean(event.detail?.productChange);
  }

  function reattachPreservedBuybox() {
    if (!preservedBuybox) return;

    const slot = document.querySelector("[data-convert-variant-slot]");
    if (slot && !slot.contains(preservedBuybox)) {
      slot.appendChild(preservedBuybox);
    }

    preservedBuybox = null;
  }

  function bindProductRerenderReattach(form) {
    if (!form || form.dataset.convertPriceTestReattachBound === "true") return;

    form.dataset.convertPriceTestReattachBound = "true";
    form.addEventListener("product:rerender", (event) => {
      if (!onProductChangeRerender(event)) return;
      reattachPreservedBuybox();
    });
  }

  function bindReattachListeners() {
    document.querySelectorAll("[data-convert-variant-slot]").forEach((slot) => {
      const formId = slot.closest("product-rerender")?.getAttribute("observe-form");
      bindProductRerenderReattach(formId ? document.getElementById(formId) : null);
    });
  }

  document.addEventListener(
    "product:rerender",
    (event) => {
      if (!onProductChangeRerender(event)) return;

      const buybox = document.querySelector(VARIANT_BUYBOX_SELECTOR);
      if (!buybox) return;

      const slot = document.querySelector("[data-convert-variant-slot]");
      if (!slot || !slot.contains(buybox)) return;

      preservedBuybox = buybox;
      buybox.remove();
    },
    true
  );

  function init() {
    relocatePdpConvertVariantBuybox();
    bindReattachListeners();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
